<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input v-model="query.generic" class="input form-control"
               @keypress.enter="find()"
               placeholder="Pesquisar por Nome">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <div class="col-md-4">
        <button class="btn btn-outline px-5"
                :class="{ 'btn-outline-active': showFilter }"
                @click="showFilter = !showFilter">
          Filtros
        </button>
        <a href="#" v-if="hasFilter" @click.prevent="clearQueryAndFind()" class="pl-2">remover filtros</a>
      </div>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-4 mt-4 pt-2 text-right">
          <button @click="clearQueryAndFind()" class="btn btn-sm btn-outline mr-2">Limpar filtros</button>
          <button @click="find()" class="btn btn-sm btn-primary">Aplicar</button>
        </div>
      </div>
    </template>
    <hr>

    <div class="row mt-2">
      <div class="col-md-12">
        <router-link tag="button" to='/admin/custom_tables/new' class="btn btn-primary mt-1 mr-1">Novo</router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>e-mail</th>
              <th>Criado por</th>
              <th>Criado em</th>
              <th>Atualizado por</th>
              <th>Atualizado em</th>
              <th>Usuários</th>
              <th>Contas</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="customTable in customTables" :key="customTable.id">
              <td>{{ customTable.id }}</td>
              <td>{{ customTable.name }}</td>
              <td>{{ customTable.email }}</td>
              <td>{{ customTable.createdBy | datetime }}</td>
              <td>{{ customTable.createdAt | datetime }}</td>
              <td>{{ customTable.updatedBy | datetime }}</td>
              <td>{{ customTable.updatedAt | datetime }}</td>
              <td>{{ customTable.accountCount }}</td>
              <td>{{ customTable.userCount }}</td>
              <td>
                <router-link :to="`/admin/custom_tables/${customTable.id}`" class="btn btn-primary mr-1">
                  Editar
                </router-link>
                <router-link :to="`/admin/custom_tables/${customTable.id}/work`" class="btn btn-primary mr-1">
                  Trabalhar
                </router-link>
                <button @click="deleteCustomTable(customTable)" class="btn btn-outline-red">{{ 'btn.delete' | t }}</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'
  
  export default {
    components: { Pagination, SearchIcon },
    computed: {
      customTables() {
        return this.getModels || []
      }
    },
    created() {
      this.defaultModelSetting.updateQueryURL = true
      this.methods.push('account', 'user')
      this.addOrderBy('createdAt')

      this.asyncTemplateSelect({
        byURL: true
      })
    },
    data() {
      return {
        modelPathPrefix: 'admin',
        nameModel: 'CustomTable',
      }
    },
    methods: {
      deleteCustomTable(customTable) {
        if (!confirm('Tem certeza?'))
          return

        this.asyncTemplateDelete(customTable, {
          after: () => {
            this.$notify.add('CustomTable excluído')
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      }
    },
    mixins: [ModelMapper],
    name: 'Index'
  }
</script>

<style scoped>

</style>